import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Box, Button, Modal, Typography, Image } from '@iho-design-system/Loader';

/*
    - icon
*/
import CloseRedSVG from '../../assets/images/icons/close-red.svg';
import CheckGreenSVG from '../../assets/images/icons/check-green.svg';

const PaymentModal = () => {

    /*
        - defaultData
    */
    const navigate = useNavigate();
    const urlParameters = useParams();

    /*
        - managePaymentStatus
    */
    React.useEffect(() => {
        if (Object.keys(urlParameters).length !== 0) {
            document.querySelector('.paymentStatusModal').classList.remove('d-none');
        } else {
            document.querySelector('.paymentStatusModal').classList.add('d-none');
        }
    }, [urlParameters]);

    return (
        <React.Fragment>
            <Modal
                className={`paymentStatusModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(min-width:576px)': {
                            width: '360px !important'
                        }
                    }}>
                    {urlParameters.paymentStatus === 'ipg_failed_payment' &&
                        <React.Fragment>
                            <Image
                                className={`mx-auto`}
                                src={CloseRedSVG}
                                ms={{
                                    width: '65px'
                                }} />
                            <Box
                                className={`my-sm`} />
                            <Typography
                                className={`d-block text-center text-danger bg-red-ultra-light`}
                                component='h5'>
                                عملیات پرداخت شما با خطا مواجه شده است!
                            </Typography>
                            <Box
                                className={`my-lg`} />
                            <Button
                                onClick={() => navigate('/dashboard')}
                                className={`d-block mx-auto`}
                                color='danger'
                                size='sm'>
                                بازگشت
                            </Button>
                        </React.Fragment>
                    }
                    {urlParameters.paymentStatus === 'ipg_success_payment' &&
                        <React.Fragment>
                            <Image
                                className={`mx-auto`}
                                src={CheckGreenSVG}
                                ms={{
                                    width: '65px'
                                }} />
                            <Box
                                className={`my-sm`} />
                            <Typography
                                className={`d-block text-center text-success bg-green-ultra-light`}
                                component='h5'>
                                عملیات پرداخت شما با موفقیت انجام گرفت
                            </Typography>
                            <Box
                                className={`my-lg`} />
                            <Button
                                onClick={() => navigate('/dashboard')}
                                className={`d-block mx-auto`}
                                color='success'
                                size='sm'>
                                بازگشت
                            </Button>
                        </React.Fragment>
                    }
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );

}

export default PaymentModal;